'use client';

import { useSidebarPadding } from '@/hooks/useSidebarPadding';

export const HomeLogicWrapperPublic = () => {
  useSidebarPadding();

  return null;
};
